import * as S from './checkbox.styles';

interface CheckboxProps {
  label: string;
  name: string;
  onChange: any;
  value: boolean;
}

const Checkbox = ({ label, onChange, value, name }: CheckboxProps) => {
  const handleChange = (e) => {
    if (onChange) onChange(e.target.checked, name);

    // setChecked(!checked)
  };

  return (
    <S.WrapperCheck>
      <input type="checkbox" checked={value} onChange={handleChange} />
      <div className="checkmark">
        <div className="mark"></div>
      </div>
      <S.WrapperCheckLable className="label">{label}</S.WrapperCheckLable>
    </S.WrapperCheck>
  );
};

export default Checkbox;
